import uviewPlus from 'uview-plus';
import { createSSRApp } from 'vue';
import * as Pinia from 'pinia';
import { createUnistorage } from 'pinia-plugin-unistorage';
import App from './App.vue';
import './utils/legacy';

import systemStore from './store/sysConfig';

const Map = {
  navigateTo: uni.navigateTo,
  reLaunch: uni.reLaunch,
  redirectTo: uni.redirectTo,
  switchTab: uni.switchTab,
};

const initAppConfig = async () => {
  if (import.meta.env.DEV) {
    await import('../public/app-config.json').then(r => {
      console.log(r)
      systemStore.setConfig(r.default);
    });
  } else {
    await fetch(`./public/app-config.json?randomId=${Date.now()}`, { method: 'get' })
      .then(e => e.json())
      .then(data => {
        systemStore.setConfig(data);
      })
      .catch(res => {
        console.error(res, '请求app-config失败');
      });
  }
};

export function createApp() {
  ['navigateTo', 'reLaunch', 'redirectTo', 'switchTab'].forEach(method => {
    const oldMethod: Function = Map[method];
    // 多加一个入参，传入true，用来区分 push 方法
    uni[method] = function (...args) {
      if (!args[0]?.PUSH) {
        console.error(
          `注意你正在使用 ${method} 方法，请确认是否该页面不需要权限判断等！非必要请使用 route.js 中的 push 方法。`,
        );
        console.log('入参：', args);
      }
      uni.hideToast();
      oldMethod.apply(uni, args);
    };
  });

  const app = createSSRApp(App);

  const store = Pinia.createPinia();
  store.use(createUnistorage());

  app.use(store);
  app.use(uviewPlus);

  app.mixin({
    async created() {
      if (this.$mpType == 'page') {
        // 可以做页面事件拦截
        const originalOnLoad = this.$options.onLoad; // 重写页面的onLoad事件
        this.$options.onLoad = async (params: Record<string, any>) => {
          // uni.hideToast();
          if (params.pageTitle) {
            uni.setNavigationBarTitle({
              title: params.pageTitle,
            });
          }

          originalOnLoad.call(this, params);
        };
      }
    },
  });

  const oldMount = app.mount;
  app.mount = async function (...args: any) {
    try {
      await initAppConfig();
    } catch (error) {
      console.error('初始化失败', error);
    }

    const response = oldMount.apply(this, args);
    return response;
  } as any;

  return {
    app,
    Pinia,
  };
}
